import { render, staticRenderFns } from "./EpgContainer.vue?vue&type=template&id=5160f415&scoped=true&"
import script from "./EpgContainer.vue?vue&type=script&lang=js&"
export * from "./EpgContainer.vue?vue&type=script&lang=js&"
import style0 from "./EpgContainer.vue?vue&type=style&index=0&id=5160f415&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160f415",
  null
  
)

export default component.exports